
















import { Component, Vue, Prop } from 'vue-property-decorator'
import { TranslateResult } from 'vue-i18n'

@Component<ConfirmDialog>({})
export default class ConfirmDialog extends Vue {
  @Prop()
  button!: string | TranslateResult
  @Prop({ default: false, type: Boolean })
  icon!: boolean
  @Prop()
  title?: string | TranslateResult
  @Prop()
  text!: string | TranslateResult

  dialog = false

  confirm(event: Event) {
    event.preventDefault()
    this.dialog = false
    this.$emit('confirm')
  }

  cancel() {
    this.dialog = false
    this.$emit('canceld')
  }
}
